module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_11.996269d7.jpg";